import { connect } from 'react-redux';

import { send as onSendAlert } from 'ha/modules/Alertbar/actions';
import { changeLocation as onChangeLocation } from 'ha/modules/URLLocationHandler';
import requestFacebookLogin from '../actions/requestFacebookLogin';

import Root from '../components/Root';

const mapDispatchToProps = {
  requestFacebookLogin,
  onSendAlert,
  onChangeLocation,
};

export default connect(
  null,
  mapDispatchToProps,
)(Root);
